// Mock data for S Pink Nails

export const services = [
  {
    id: 1,
    title: 'Gel X Extensions',
    description: 'Long-lasting, durable gel extensions customized to your style',
    price: 'Contact for Pricing',
    icon: 'Sparkles',
  },
  {
    id: 2,
    title: 'Gel Nails',
    description: 'Natural-looking gel polish with extended wear and shine',
    price: 'Contact for Pricing',
    icon: 'Gem',
  },
  {
    id: 3,
    title: 'Dip Powder',
    description: 'Strong, lightweight powder manicure for healthy nails',
    price: 'Contact for Pricing',
    icon: 'Droplet',
  },
  {
    id: 4,
    title: 'Manicure & Pedicure',
    description: 'Complete nail care with shaping, buffing, and polish',
    price: 'Contact for Pricing',
    icon: 'Hand',
  },
  {
    id: 5,
    title: 'Nail Art & Custom Designs',
    description: 'Express your creativity with unique, personalized nail art',
    price: 'Contact for Pricing',
    icon: 'Palette',
  },
  {
    id: 6,
    title: 'Fill-Ins & Repairs',
    description: 'Professional maintenance to keep your nails looking fresh',
    price: 'Contact for Pricing',
    icon: 'Wrench',
  },
];

export const features = [
  {
    id: 1,
    title: 'Professional & Clean',
    description: 'Maintaining the highest standards of hygiene and cleanliness',
    icon: 'ShieldCheck',
  },
  {
    id: 2,
    title: 'High-Quality Products',
    description: 'Using only premium brands and materials for lasting results',
    icon: 'Award',
  },
  {
    id: 3,
    title: 'Custom Designs Available',
    description: 'Bring your vision to life with personalized nail art',
    icon: 'Brush',
  },
  {
    id: 4,
    title: 'Flexible Scheduling',
    description: 'Convenient appointment times that work with your busy life',
    icon: 'Calendar',
  },
  {
    id: 5,
    title: 'Relaxing Experience',
    description: 'Friendly service in a comfortable, welcoming environment',
    icon: 'Heart',
  },
  {
    id: 6,
    title: 'Beautiful Results',
    description: 'Long-lasting, stunning nails that exceed expectations',
    icon: 'Star',
  },
];

export const gallery = [
  {
    id: 1,
    src: 'https://images.unsplash.com/photo-1519014816548-bf5fe059798b?crop=entropy&cs=srgb&fm=jpg&w=800&q=80',
    alt: 'Pink luxury nail art with ME LOVE text',
    category: 'Nail Art',
  },
  {
    id: 2,
    src: 'https://images.unsplash.com/photo-1720343409646-960f6dcccae3?crop=entropy&cs=srgb&fm=jpg&w=800&q=80',
    alt: 'Elegant hands with luxury rings and nail art',
    category: 'Gel X Extensions',
  },
  {
    id: 3,
    src: 'https://images.unsplash.com/photo-1571290274554-6a2eaa771e5f?crop=entropy&cs=srgb&fm=jpg&w=800&q=80',
    alt: 'Colorful creative nail art designs',
    category: 'Nail Art',
  },
  {
    id: 4,
    src: 'https://images.unsplash.com/photo-1604654894610-df63bc536371?crop=entropy&cs=srgb&fm=jpg&w=800&q=80',
    alt: 'Dark elegant gel polish nails',
    category: 'Gel Polish',
  },
  {
    id: 5,
    src: 'https://images.pexels.com/photos/704815/pexels-photo-704815.jpeg?auto=compress&cs=tinysrgb&w=800',
    alt: 'Professional gel x extension set',
    category: 'Gel X Extensions',
  },
  {
    id: 6,
    src: 'https://images.pexels.com/photos/887352/pexels-photo-887352.jpeg?auto=compress&cs=tinysrgb&w=800',
    alt: 'Creative nail art design',
    category: 'Nail Art',
  },
  {
    id: 7,
    src: 'https://images.unsplash.com/photo-1632345031435-8727f6897d53?crop=entropy&cs=srgb&fm=jpg&w=800&q=80',
    alt: 'Professional manicure service in action',
    category: 'Service',
  },
  {
    id: 8,
    src: 'https://images.unsplash.com/photo-1619607146034-5a05296c8f9a?crop=entropy&cs=srgb&fm=jpg&w=800&q=80',
    alt: 'Nail polish display in luxury salon',
    category: 'Service',
  },
  {
    id: 9,
    src: 'https://images.unsplash.com/photo-1690749138086-7422f71dc159?crop=entropy&cs=srgb&fm=jpg&w=800&q=80',
    alt: 'Professional manicure service',
    category: 'Service',
  },
  {
    id: 10,
    src: 'https://images.unsplash.com/photo-1610992015762-45dca7fa3a85?crop=entropy&cs=srgb&fm=jpg&w=800&q=80',
    alt: 'Elegant nude gel nails',
    category: 'Gel Polish',
  },
  {
    id: 11,
    src: 'https://images.pexels.com/photos/3997379/pexels-photo-3997379.jpeg?auto=compress&cs=tinysrgb&w=800',
    alt: 'Professional nail salon service',
    category: 'Service',
  },
  {
    id: 12,
    src: 'https://images.unsplash.com/photo-1610992015732-2449b76344bc?crop=entropy&cs=srgb&fm=jpg&w=800&q=80',
    alt: 'Manicure service professional',
    category: 'Gel X Extensions',
  },
];

export const galleryCategories = ['All', 'Gel X Extensions', 'Gel Polish', 'Nail Art', 'Service'];

export const testimonials = [
  {
    id: 1,
    name: 'Sarah Johnson',
    time: '2 weeks ago',
    text: 'Absolutely love my nails! The attention to detail is incredible. I always leave feeling pampered and beautiful. Highly recommend!',
    rating: 5,
  },
  {
    id: 2,
    name: 'Emily Rodriguez',
    time: '1 month ago',
    text: "Best nail tech I've ever been to! So professional and the quality is outstanding. My gel manicure lasted over 3 weeks without chipping.",
    rating: 5,
  },
  {
    id: 3,
    name: 'Jessica Martin',
    time: '3 weeks ago',
    text: 'The custom nail art is amazing! She listened to my ideas and created something even better than I imagined. Clean studio and friendly service.',
    rating: 5,
  },
  {
    id: 4,
    name: 'Ashley Thompson',
    time: '1 week ago',
    text: 'Such a relaxing experience! The studio is beautiful and she really takes her time to make sure everything is perfect. Worth every penny!',
    rating: 5,
  },
];

export const contactInfo = {
  phone: '(847) 356-6345',
  email: 'spinknailspa@gmail.com',
  instagram: '@gpinknailsspa',
  address: '2568 N Illinois 83, Round Lake Beach, IL 60073',
  facebookUrl: 'https://www.facebook.com/p/GPink-Nails-Spa-61579173698755/',
};

export const studioHours = [
  { day: 'Monday', hours: '9:00 AM - 7:00 PM' },
  { day: 'Tuesday', hours: 'Closed' },
  { day: 'Wednesday', hours: '9:00 AM - 7:00 PM' },
  { day: 'Thursday', hours: '9:00 AM - 7:00 PM' },
  { day: 'Friday', hours: '9:00 AM - 7:00 PM' },
  { day: 'Saturday', hours: '9:00 AM - 7:00 PM' },
  { day: 'Sunday', hours: '10:00 AM - 6:00 PM' },
];

export const heroImage =
  'https://images.unsplash.com/photo-1519014816548-bf5fe059798b?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85';
